import { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import styles from './SidebarItem.module.css';

interface SidebarItemProps {
	icon: ReactNode;
	label: string;
	to: string;
	onClick?: () => void;
}

export const SidebarItem = ({ icon, label, to, onClick }: SidebarItemProps) => {
	if (onClick) {
		return (
			<div className={styles.itemWrapper}>
				<button onClick={onClick} className={styles.item}>
					<span className={styles.icon}>{icon}</span>
					<span className={styles.label}>{label}</span>
				</button>
			</div>
		);
	}

	return (
		<NavLink
			to={to}
			className={({ isActive }) => `${styles.itemWrapper} ${isActive ? styles.active : ''}`}
		>
			{({ isActive }) => (
				<div className={`${styles.item} ${isActive ? styles.itemActive : ''}`}>
					<span className={styles.icon}>{icon}</span>
					<span className={styles.label}>{label}</span>
				</div>
			)}
		</NavLink>
	);
};
